<template>
  <div class="page_bg agency_bg" style="margin:0;">
    <!-- 顶部返回 -->
    <div class="back_top_name  flex-r-sb-c" style=" padding: 0.32rem;font-size: 0.43rem;color: #fff;">
      <div class="flex-r-c-c" style="width: 2rem;" @click="backPath"><van-icon name="arrow-left"
                                                                               style="margin-top: 0.06rem;"
      />返回</div>
      <div class="top_name ">请选择代理品牌</div>
      <div style="width: 2rem;" />
    </div>
    <div class="agency_brand">
      <div class="agency_brand_table">
        <van-tabs v-model="active" swipeable animated @change="swipeableBrand($event)">
          <van-tab v-for="(item,index) in agencyBrandList" :key="index">
            <template slot="title">
              <van-badge :content="item.cityCount" color="#EA5B56">
                <div class="table_title flex-c-c-c" @click="changeBrand(item)">
                  <van-image width="2.24rem" height="1.2rem" :src="item.logoUrl" />
                  <van-icon name="play" class="table_title_icon" color="#fff" />
                </div>
              </van-badge>
            </template>
            <template slot="default">
              <div class="table_default">
                <van-image width="3.73rem" height="0.75rem" style="margin-left: 0.32rem;"
                           :src="require('./../../assets/agency_title01.png')"
                />
                <div class="table_default_msg">【{{ item.brandName }}】 {{ brandInfo.intro }} </div>
              </div>

              <div class="agency_brand_city">
                <div class="city_top flex-r-sb-c">
                  <van-image width="3.73rem" height="1.07rem" style="margin-left: 0.32rem;"
                             :src="require('./../../assets/UI2/00.png')"
                  />
                  <div class="city_top_icon flex-r-c-c" @click="openPopup()">
                    <van-icon name="add" color="#1084D1" size="0.45rem"
                              style="margin-right: 0.1rem;margin-top: 0.05rem;"
                    />选择城市
                  </div>
                </div>
                <!-- 已选择的城市 -->
                <div class="city_choosed">
                  <div v-for="(item,index) in choodedList.provinceList" :key="index" class="city_choosed_item">
                    <div class="item_province">{{ item.provinceName }}</div>
                    <div class="item_city flex-r-s-c">
                      <div v-for="(item_city,index_city) in item.cityList" :key="index_city" class="item_city_name">
                        {{ item_city.cityName }}
                        <div class="item_city_close" @click="delCity(item_city.cityId)"><van-icon name="cross" /></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="agency_brand_tips">
                <div class="tips_msg flex-r-s-s">
                  <div style="color: #415A88;height: 0.64rem;line-height: 0.64rem;margin-right: 0.13rem;">●</div>
                  <!-- <div>单个品牌单个城市满足 <span class="tips_msg_bold">5000元/月</span> 销售任务即可成为城市 <span
                    class="tips_msg_bold"
                  >独家代理</span>
                  </div> -->
                  <div>单个品牌单个城市满足销售任务即可成为城市 <span
                    class="tips_msg_bold"
                  >独家代理</span>
                  </div>
                </div>
                <van-divider dashed :style="{ borderColor: '#A1A1A1', margin: '0.21rem' }" />
                <div class="tips_msg  flex-r-s-s">
                  <div style="color: #415A88;height: 0.64rem;line-height: 0.64rem;margin-right: 0.13rem;">●</div>
                  <div>城市独家代理 <span class="tips_msg_bold">优先延续</span> 代理权益 </div>
                </div>
              </div>
              <div class="agency_brand_policy" style="padding-bottom: 3.5rem;padding-top: 0.2rem;">
                <van-image width="3.73rem" height="0.75rem" style="margin-left: 0.32rem;margin-bottom: 0.16rem;"
                           :src="require('./../../assets/agency_title02.png')"
                />
                <div class="agency_brand_policy_msg msg_bg01 flex-r-s-c">
                  <span class="msg_title">小区域合作</span>
                  <span class="msg_msg van-multi-ellipsis--l2">{{ brandInfo.agentBusinessPolicyOne }}</span>
                </div>
                <div class="agency_brand_policy_msg msg_bg02 flex-r-s-c">
                  <span class="msg_title">超低月任务</span>
                  <span class="msg_msg van-multi-ellipsis--l2">{{ brandInfo.agentBusinessPolicyTwo }}</span>
                </div>
                <div class="agency_brand_policy_msg msg_bg03 flex-r-s-c">
                  <span class="msg_title">高额返点</span>
                  <span class="msg_msg van-multi-ellipsis--l2">{{ brandInfo.agentBusinessPolicyThree }}</span>
                </div>
              </div>
            </template>
          </van-tab>
        </van-tabs>
      </div>
      <div class="agency_brand_bottom">
        <div class="bottom_price flex-c-s-s">
          <div style="margin-top: 0.27rem;">您当前已选 <span style="color: #F20000;">{{ brandPrice.brandCount }}</span>
            个品牌，<span style="color: #F20000;">{{ brandPrice.cityCount }}</span> 个城市</div>
          <div>采购满 <span style="color: #F20000;">{{ brandPrice.targetAmountTotal }}</span> 元即可立即锁定城市代理！</div>
        </div>
        <div class="bottom_btn flex-c-c-c">
          <div :class="brandPrice.cityCount*1>0 ?
            'bottom_btn_sub bottom_btn_sub_actived':'bottom_btn_sub '" @click="jumProList(brandPrice.cityCount*1>0)"
          >
            立即下单申请代理</div>
        </div>
      </div>
    </div>
    <!-- 选择省市 -->
    <van-popup v-model="show" round position="bottom" :style="{ height: '50%' }" @close="closePopup">
      <div class="popup_content">
        <div class="popup_content_title flex-r-sb-c">
          <div> 请选择代理城市 </div>
          <div class="popup_content_title_confirm" @click="closePopup();show = false">确定</div>
        </div>
        <!-- 省市列表 -->
        <div v-if="provinceList.length > 0" class="popup_content_lists flex-r-s-c">
          <div class="lists_content ">
            <div v-for="(province_item,province_index) in provinceList"
                 :id="popupProvinceId === province_item.provinceId ? 'province_active_id':''" :key="province_index"
                 :class="province_item.markType === 1 ? 'lists_province_item lists_province_item_actived':'lists_province_item'"
                 @click="chooseProvince(province_item)"
            >
              <div class="flex-r-sb-c" style="padding-left: 0.45rem;padding-right: 0.43rem;width: 100%;">
                <span>{{ province_item.provinceName }}</span>
                <van-icon v-if="popupProvinceId === province_item.provinceId" name="success" />
              </div>
            </div>
          </div>
          <div class="lists_content ">
            <div v-for="(city_item,city_index) in cityList" :key="city_index"
                 :class="city_item.markType === 1 ? 'lists_province_item lists_city_item_actived':'lists_province_item'"
                 @click="chooseCity(city_item)"
            >
              <div class="flex-r-sb-c" style="padding-left: 0.45rem;padding-right: 0.43rem;width: 100%;">
                <span>{{ city_item.cityName }}</span>
                <van-icon v-if="city_item.markType === 1" name="success" />
              </div>

            </div>
          </div>
        </div>
        <div v-else class="popup_content_lists_empty flex-c-c-c">
          <van-image width="6.13rem" height="4.27rem"
                     src="https://hxxxkj-oss-cdn.xiaoyi120.com/sysx-xcx/mall/empty3.png"
          />
          <div class="empty_tips">无可用代理城市，看看其他品牌吧！</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import './index.scss'
import {
  apiWholesaleAgent_list, apiWholesaleAgent_intro, apiWholesaleAgent_cartList,
  apiWholesaleAgent_removeCity, apiWholesaleAgent_cartStatistics, apiWholesaleAgent_provinceSelection, apiWholesaleAgent_citySelection,
  apiWholesaleAgent_addCity
} from '@/api/agency'
export default {
  data() {
    return {
      wholesaleAgentBrandId: null, // 当前选择的品牌id
      agencyBrandList: [],
      brandInfo: {},
      choodedList: {},
      brandPrice: {},
      active: 0,
      subActived: false,
      // popup相关
      show: false,
      popupProvinceId: '', // 当前省份id
      provinceList: [], // 省份列表
      cityList: [] // 城市列表
    }
  },
  created() {
    this.wholesaleAgentBrandId = this.$route.query.wholesaleAgentBrandId || null
    this.loadAgencyList()
  },
  methods: {
    backPath() { window.history.back() },
    swipeableBrand(e) {
      this.changeBrand(this.agencyBrandList[e])
    },
    changeBrand(item) {
      this.loadBrandIntro(item.wholesaleAgentBrandId)
      this.loadTotalInfo()
    },
    // 加载代理品牌列表
    loadAgencyList() {
      apiWholesaleAgent_list({ page: 1, limit: 999 }).then(res => {
        this.agencyBrandList = res.data.list
        if (this.wholesaleAgentBrandId) {
          this.active = this.agencyBrandList.findIndex(v => v.wholesaleAgentBrandId === this.wholesaleAgentBrandId)
        }
        this.loadBrandIntro(this.wholesaleAgentBrandId ? this.wholesaleAgentBrandId : res.data.list[0].wholesaleAgentBrandId)
      })
      this.loadTotalInfo()
    },
    // 加载简介
    loadBrandIntro(wholesaleAgentBrandId) {
      apiWholesaleAgent_intro(wholesaleAgentBrandId).then(res => {
        this.brandInfo = res.data
        this.loadCityInfo(wholesaleAgentBrandId)
      })
    },
    // 加载统计信息
    loadTotalInfo() {
      apiWholesaleAgent_cartStatistics().then(res => { this.brandPrice = res.data })
    },
    // 加载已选择城市信息
    loadCityInfo(wholesaleAgentBrandId) {
      apiWholesaleAgent_cartList(wholesaleAgentBrandId).then(res => { this.choodedList = res.data })
    },
    // 删除城市
    delCity(cityId) {
      apiWholesaleAgent_removeCity({ cityId: cityId, wholesaleAgentBrandId: this.brandInfo.wholesaleAgentBrandId }).then(res => {
        this.loadCityInfo(this.brandInfo.wholesaleAgentBrandId)
        this.loadTotalInfo()
        this.loadProvinceInfo()
        apiWholesaleAgent_list({ page: 1, limit: 999 }).then(res => {
          this.agencyBrandList = res.data.list
        })
      })
    },
    // 打开popup
    openPopup() {
      this.show = true
      this.popupProvinceId = ''
      this.cityList = []
      var isChoosed = false
      // 加载省份列表
      apiWholesaleAgent_provinceSelection(this.brandInfo.wholesaleAgentBrandId).then(res => {
        this.provinceList = res.data.list
        for (const i in res.data.list) {
          if (res.data.list[i].markType === 1) {
            this.popupProvinceId = res.data.list[i].provinceId
            // 加载城市列表
            this.chooseProvince(res.data.list[i])
            isChoosed = true
            break
          }
        }
        if (!isChoosed) {
          this.popupProvinceId = res.data.list[0].provinceId
          this.chooseProvince(res.data.list[0])
        }
      })
    },
    // 加载省信息
    loadProvinceInfo() {
      apiWholesaleAgent_provinceSelection(this.brandInfo.wholesaleAgentBrandId).then(res => { this.provinceList = res.data.list })
    },
    // 选择省
    chooseProvince(item) {
      this.popupProvinceId = item.provinceId
      // 加载城市列表
      apiWholesaleAgent_citySelection({
        page: 1, limit: 999,
        provinceId: item.provinceId, wholesaleAgentBrandId: this.brandInfo.wholesaleAgentBrandId
      }).then(res => {
        this.cityList = res.data.list
      })
    },
    // 选择市
    chooseCity(item) {
      // 添加城市
      if (item.markType === 0) {
        apiWholesaleAgent_addCity({ cityId: item.cityId, wholesaleAgentBrandId: this.brandInfo.wholesaleAgentBrandId }).then(res => {
          item.markType = 1
          this.loadProvinceInfo()
          this.loadTotalInfo()
          this.loadCityInfo(this.brandInfo.wholesaleAgentBrandId)
          apiWholesaleAgent_list({ page: 1, limit: 999 }).then(res => {
            this.agencyBrandList = res.data.list
          })
        })
      }
      // 删除城市
      if (item.markType === 1) {
        item.markType = 0
        this.delCity(item.cityId)
      }
    },
    // 返回省份
    backProvince() {
      this.popupProvinceId = ''
      // 加载省份列表
      apiWholesaleAgent_provinceSelection(this.brandInfo.wholesaleAgentBrandId).then(res => { this.provinceList = res.data.list })
    },
    // 关闭弹框
    closePopup() {
      this.loadTotalInfo()
      this.loadCityInfo(this.brandInfo.wholesaleAgentBrandId)
    },
    // 进入商品列表
    jumProList(flag) {
      if (flag) {
        this.$router.push('/agency/agencyProduct?wholesaleAgentBrandId=' + this.brandPrice.brandList[0].wholesaleAgentBrandId)
      }
    }
  }
}
</script>

<style>
</style>
